import ApiService from "../ApiService";

export default class RoleService {
  static getModule = async (params) => {
    const instance = await ApiService();
    return instance.get("/module");
  };

  static getData = async (params) => {
    let search;
    let position;
    let cursor;
    if (params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }
    if (params.position !== "") {
      position = `&progress=${params.position}`;
    }
    if (params.search !== "") {
      search = `&keyword=${params.search}`;
    }
    const instance = await ApiService();
    return instance.get(
      `/role?num=${params.num}${cursor ? cursor : ""}${
        position ? position : ""
      }${search ? search : ""}`
    );
  };
  static storeData = async (value) => {
    const instance = await ApiService();
    const params = {
      name: value.name,
      default_page: value.default_page || "/home",
      modules: value.modules,
      type: value.type,
      is_admin: value.is_admin
    };
    return instance.post(`/role`, params);
  };

  static getDataRole = async (value) => {
    const instance = await ApiService();
    return instance.get(`/role/${value.id}`);
  };

  static putData = async (value) => {
    const instance = await ApiService();
    const params = {
      id: value.id,
      name: value.name,
      default_page: value.default_page || "/home",
      modules: value.modules,
      type: value.type,
      is_admin: value.is_admin,
      is_courier: value.is_courier
    };
    return instance.put(`/role/${value.id}`, params);
  };
  static deleteData = async (params) => {
    const instance = await ApiService();
    return instance.delete(`/role/${params.id}`);
  };
}
